import { memo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AllDialogs from '../../components/AllDialogs';

const mapState = ({ 
	dialogs: { 
		confirm,
		readingNotification,
		allowancebeingNotified,
		confirmNotificaton
	}}) => {
	return {
		confirm: {...confirm},
		readingNotification: {...readingNotification},
		allowancebeingNotified: {...allowancebeingNotified},
		confirmNotificaton: {...confirmNotificaton}
	};
};

const mapDispatch = (dispatch) => ({
	closeReadingNotificationDialog: () => dispatch.dialogs.closeReadingNotificationDialog(),
	subscribeUserToPush: () =>  dispatch.dialogs.subscribeUserToPush(),
	unSubscribeUserToPush: () => dispatch.dialogs.unSubscribeUserToPush(),
	setNoCache: () => dispatch.navigation.setNoCache(),
	confirmClose: () => dispatch.dialogs.closeConfirmDialogAsync(),
});

export default connect(mapState, mapDispatch)(withRouter(memo(AllDialogs)));
